import React from 'react';

export default class ViewServices extends React.Component {

    makeHeader() {
        let header = this.props.history;
        if (header.length) {
            let obj = {};
            header.map((v) => {
                obj = v; 
            })
            header = obj.header;
            let headerrows = [];
            header.map((c) => {
                headerrows.push(<th><center>{c.name}<br/>{c.hrs+' Hrs'}</center></th>)
            })
            return headerrows;
        }
        return [];
    }

    makerows(customerid, masterids) {
        let header = this.props.history;
        if (header.length) {
            let obj = {};
            header.map((v) => {
                obj = v; 
            })
            let headerrows = [];
            header = obj.data;
            header.map((c) => {
                if (c.customerid == customerid && c.masterids == masterids) {
                    if (c.status == 'NILL') {
                        headerrows.push(
                            <td><center><b>NILL</b></center></td>
                        ) 
                    }
                    else {
                        headerrows.push(
                            <td>
                                {"Excepted Service Date"}
                                <br/>
                                {c.e_date}
                                <br/>
                                {"Actual Service Date"}<br/>
                                {c.s_date+" / "+c.s_hrs+" / "+c.refernce_no}
                            </td>
                        )
                    }
                }
            })
            return headerrows;
        }
        return [];
    }

    customerFilter = () => {
        let header = this.props.history;
        if (header.length) {
            let obj = {};
            header.map((v) => {
                obj = v; 
            })
            header = obj.data;
            return header.filter((v,i,a)=>a.findIndex(t=>(t.customerid===v.customerid && t.masterids===v.masterids))===i);
        }
        return [];
    }

    render() {
        let customerFilter = this.customerFilter();
        let i = 1;
        return (
            <div>
                <div style={{overflow: 'auto', overflow: 'scroll', width: '98vw', height: '95vh' }}>
                    <table id="table" width="100%">
                        <tr id="th">
                            <th><center>Sino</center></th>
                            <th><center>Customer Name</center></th>
                            <th><center>Machine No</center></th>
                            {this.makeHeader()}
                        </tr>
                        {
                            customerFilter.map((c) => {
                                return (
                                    <tr>
                                        <td>{i++}</td>
                                        <td>{c.customername}</td>
                                        <td>{c.machine_no}</td>
                                        {this.makerows(c.customerid, c.masterids)}
                                    </tr>
                                )
                            })
                        }
                    </table>
                </div>
            </div>
        );
    }
}